export default {
    base: {
        caretColor: '#0075FF'
    }
};
